export const state = {
  modalViewFormaDePagamento: false,
  formasDePagamentos: [],
  formaDePagamento: {},
  formaDePagamentoMarcaddas: []
};

export default {};
